import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import Api from '../../../../../services/Api'
import DefaultCardImage from '../components/DefaultCardImage/DefaultCardImage'
import { useGetBaseUri } from '../../../../../hooks/useYetiSwapNFTCollection'
import { IDefaultCard } from '../Card/IDefaultCard'
import BaseDetail from '../../Base/Detail/BaseDetail'

export default function DefaultDetail(props: INFDetailFormatted) {
  const { tokenItem } = props
  const nftBaseUri = useGetBaseUri()
  const [detailTokenItem, setDetailTokenItem] = useState<IDefaultCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  return (
    <BaseDetail
      {...props}
      tokenItemName={detailTokenItem ? detailTokenItem.name : ''}
      properites={detailTokenItem ? detailTokenItem.attributes : []}
      externalUrl={detailTokenItem?.externalUrl}
      description={detailTokenItem ? <div>{detailTokenItem.description}</div> : <></>}
      officalCollection={props.collection.creatorAddress !== ''}
    >
      <DefaultCardImage item={detailTokenItem} baseURI={nftBaseUri} />
    </BaseDetail>
  )
}
